<template>
  <div>
    <v-alert v-if="getSubscriptionsWaitingForPayment" type="warning" text>
      {{ $t('warning') }}
      <span v-if="getSubscriptionsWaitingForPayment === 1">{{ $t('inactive-subscription-sing') }}</span>
      <span v-else>{{ getSubscriptionsWaitingForPayment }} {{ $t('inactives-subscription-plu') }}</span>
      {{ $t('payment-fail') }}<a href="#/account/subscriptions">{{ $t('subscription-page') }}</a>
      {{ $t('confirm-payment-method') }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'AppMainPrepend',
  data () {
    return {
      persist: ['alerts'],
      alerts: {
      }
    }
  },
  computed: {
    getSubscriptionsWaitingForPayment () {
      let inactive = 0
      Object.values(this.$account.getSubscriptions()).forEach(subscription => {
        if (['incomplete', 'past_due'].includes(subscription.status)) inactive++
      })
      return inactive
    },
  },
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"confirm-payment-method": "to check and confirm the default payment method for your account.",
		"inactive-subscription-sing": " an inactive subscription",
		"inactives-subscription-plu": " inactive subscriptions",
		"payment-fail": " due to payment failure. Meeting on",
		"promotion-text": "We are celebrating the end of the beta, until June 30 enjoy 30% off an annual subscription with the promotion code",
		"subscription-page": "your subscription page",
		"warning": "Attention you have"
	},
	"es": {
		"confirm-payment-method": "para verificar y confirmar el método de pago predeterminado para su cuenta.",
		"inactive-subscription-sing": " una suscripción inactiva",
		"inactives-subscription-plu": " suscripciones inactivas",
		"payment-fail": " debido a falta de pago. Quedamos en",
		"promotion-text": "Estamos celebrando el final de la beta, hasta el 30 de junio disfruta de un 30% de descuento en una suscripción anual con el código de promoción",
		"subscription-page": "su página de suscripción",
		"warning": "Atencion tiene"
	},
	"fr": {
		"confirm-payment-method": "pour vérifier et confirmer la méthode de paiement par défaut de votre compte.",
		"inactive-subscription-sing": " une souscription inactive",
		"inactives-subscription-plu": " souscriptions inactives",
		"payment-fail": " pour cause d'echec de paiement. Rendez-vous sur ",
		"promotion-text": "Nous fêtons la fin de la bêta, jusqu'au 30 juin profitez de 30% de réduction sur un une souscription annuelle avec le code promotion",
		"subscription-page": "votre page d'abonnement ",
		"warning": "Attention, vous avez"
	},
	"it": {
		"confirm-payment-method": "per verificare e confermare il metodo di pagamento predefinito per il tuo account.",
		"inactive-subscription-sing": " un abbonamento inattivo",
		"inactives-subscription-plu": " abbonamenti inattivi",
		"payment-fail": " a causa di un errore di pagamento. Vai su",
		"promotion-text": "Festeggiamo la fine della beta, fino al 30 giugno approfitta del 30% di sconto su un abbonamento annuale con il codice promozionale",
		"subscription-page": "la tua pagina di abbonamento",
		"warning": "Attenzione, hai"
	},
	"pt": {
		"confirm-payment-method": "para verificar e confirmar o método de pagamento predefinido da sua conta.",
		"inactive-subscription-sing": " uma subscrição inativa",
		"inactives-subscription-plu": " subscrições inativas",
		"payment-fail": " devido a falha de pagamento. Aceda à",
		"promotion-text": "Estamos a celebrar o fim da beta, até 30 de junho aproveite 30% de desconto numa subscrição anual com o código de promoção",
		"subscription-page": "a sua página de subscrição",
		"warning": "Atenção, tem"
	},
	"pl": {
		"confirm-payment-method": "aby sprawdzić i potwierdzić domyślną metodę płatności dla Twojego konta.",
		"inactive-subscription-sing": " nieaktywna subskrypcja",
		"inactives-subscription-plu": " nieaktywne subskrypcje",
		"payment-fail": " z powodu nieudanej płatności. Przejdź na",
		"promotion-text": "Świętujemy koniec wersji beta, do 30 czerwca skorzystaj z 30% zniżki na roczną subskrypcję z kodem promocyjnym",
		"subscription-page": "Twoją stronę subskrypcji",
		"warning": "Uwaga, masz"
	}
}
</i18n>
